import { FundingForm } from "../types/form-types.interface";

// Sem desembolso positivo (recompra que zera a operação, ou ainda não calculado) a divisão
// gera NaN, que realimentaria o valueChanges do fundingForm em loop (ACM-495).
export const splitDisbursementByFundingUsed = (totalDisbursement: number, fundingUsed: number): FundingForm => {
    if (!(totalDisbursement > 0)) {
        return { accountBalance: 0, accountBalanceRate: 100, fundingUsed: 0, fundingRate: 0 };
    }

    const usedFunding = fundingUsed || 0;
    const accountBalance = totalDisbursement - usedFunding;
    const accountBalanceRate = (accountBalance * 100) / totalDisbursement;

    return {
        accountBalance,
        accountBalanceRate,
        fundingUsed: usedFunding,
        fundingRate: 100 - accountBalanceRate,
    };
};

// Com desembolso, fundingUsed não é regravado: o valor do evento já pode ter sido recalculado
// pelos ramos de percentual, e sobrescrevê-lo faz o valueChanges oscilar em ponto flutuante.
export const buildFundingUsedChangePatch = (totalDisbursement: number, fundingUsed: number): Partial<FundingForm> => {
    const { fundingUsed: normalizedFundingUsed, ...derivedFields } = splitDisbursementByFundingUsed(
        totalDisbursement,
        fundingUsed,
    );

    return totalDisbursement > 0 ? derivedFields : { ...derivedFields, fundingUsed: normalizedFundingUsed };
};
